var widget_default = {
  "card": "a90EV",
  "link": "QeAcW",
  "container": "_2-KMg",
  "image": "BuBgd",
  "right": "skH2c",
  "cardLayout": "_8eEMN",
  "content": "pp0h5",
  "title": "f0-LX",
  "subtitle": "XtotK",
  "button": "B-k0n",
  "button_disabled": "_7Ly5i",
  "buttonText": "yqDh7",
  "slimLayout": "b8mnV",
  "rtl": "uYjel",
  "ltr": "D91xE"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
